import { ROUTES } from './constants'
import { unifiedJobStreamService } from '../services/unifiedJobStreamService'

export const performLogoutCleanup = async (queryClient = null, navigate = null) => {
    try {
        unifiedJobStreamService.disconnect()

        const deviceId = localStorage.getItem('deviceId')

        const keysToRemove = [
            'access',
            'refresh',
            'user',
            'isGuest',
            'active_jobs_persist_v1',
            'mini_app_consents',
            'isSocialUser'
        ]

        keysToRemove.forEach((key) => localStorage.removeItem(key))

        if (deviceId) {
            localStorage.setItem('deviceId', deviceId)
        }

        if (queryClient) {
            try {
                await queryClient.cancelQueries()
                queryClient.clear()
                await queryClient.resetQueries({ exact: false })
            } catch (error) {
                console.error('Error clearing query cache:', error)
            }
        }

        if (navigate) {
            navigate(ROUTES.login, { replace: true })
        } else if (typeof window !== 'undefined') {
            window.location.href = ROUTES.login
        }
    } catch (error) {
        console.error('Error during logout cleanup:', error)
        if (typeof window !== 'undefined') {
            window.location.href = ROUTES.login
        }
    }
}


export const getQueryClient = () => {
    if (typeof window !== 'undefined' && window.__QUERY_CLIENT__) {
        return window.__QUERY_CLIENT__
    }
    return null
}
